export const privacy = {
  "header": {
    "badge": "Προσωπική πληροφορία",
    "title": "Πολιτική Απορρήτου"
  },
  "content": {
    "intro": "Η προστασία του απορρήτου και των προσωπικών σας δεδομένων αποτελεί απόλυτη προτεραιότητα για το DONKEY TRAVEL. Αυτή η πολιτική περιγράφει λεπτομερώς τον τρόπο με τον οποίο συλλέγουμε, επεξεργαζόμαστε και προστατεύουμε τις πληροφορίες σας.",
    "collection": {
      "title": "1. Συλλογή δεδομένων",
      "text": "Συλλέγουμε μόνο τα δεδομένα που είναι απολύτως απαραίτητα για τη σωστή λειτουργία της πλατφόρμας: πληροφορίες για τη δημιουργία του λογαριασμού σας (επώνυμο, όνομα, email), συνδέσμους προς τις δημόσιες ανακοινώσεις σας (Airbnb) και τις ταξιδιωτικές σας προτιμήσεις και διαθεσιμότητα. Οι κωδικοί πρόσβασης είναι κρυπτογραφημένοι και τα δεδομένα πληρωμής υποβάλλονται σε επεξεργασία από τον ασφαλή συνεργάτη μας Stripe."
    },
    "usage": {
      "title": "2. Χρήση των δεδομένων σας",
      "text": "Οι πληροφορίες σας χρησιμοποιούνται για: \n- Ελέγξτε την καταλληλότητά σας (βαθμολόγηση 4,5+) \n- Διαχειριστείτε τη συνδρομή σας \n- Διευκολύνετε τη σύνδεση με άλλα μέλη \n- Παρέχετε εξατομικευμένες προτάσεις μέσω της Έξυπνης αντιστοίχισης \n- Βελτίωση των υπηρεσιών μας και επίλυση τεχνικών προβλημάτων."
    },
    "sharing": {
      "title": "3. Κοινή χρήση πληροφοριών",
      "text": "ΠΟΤΕ δεν θα πουλήσουμε τα προσωπικά σας δεδομένα σε τρίτους. Η κοινή χρήση τους περιορίζεται αυστηρά σε λειτουργικούς σκοπούς με τους αξιόπιστους παρόχους υπηρεσιών μας (φιλοξενία Ιστού, εργαλείο πληρωμής). Εκτός αυτού του πλαισίου, τα δεδομένα σας μοιράζονται μόνο μεταξύ μελών για την οργάνωση μιας ανταλλαγής (και μόνο την ακριβή διεύθυνση μετά την επικύρωση μιας ανταλλαγής)."
    },
    "security": {
      "title": "4. Ασφάλεια",
      "text": "Τα πιο ισχυρά πρωτόκολλα ελέγχου ταυτότητας και ασφάλειας υπάρχουν για την προστασία των δεδομένων σας από μη εξουσιοδοτημένη πρόσβαση, τροποποίηση, αποκάλυψη ή καταστροφή."
    },
    "rights": {
      "title": "5. Τα δικαιώματά σας (GDPR)",
      "text": "Σύμφωνα με τους Γενικούς Κανονισμούς Προστασίας Δεδομένων, έχετε το δικαίωμα πρόσβασης, διόρθωσης, φορητότητας ή διαγραφής των προσωπικών σας δεδομένων ανά πάσα στιγμή. Μπορείτε να ασκήσετε αυτό το δικαίωμα από τις ρυθμίσεις του λογαριασμού σας ή γράφοντάς μας στο dpo@donkey.travel."
    },
    "cookies": {
      "title": "6. Μπισκότα",
      "text": "Χρησιμοποιούμε βασικά cookies για τη διατήρηση της συνεδρίας σύνδεσής σας, καθώς και ανώνυμα αναλυτικά cookies για να κατανοήσουμε πώς χρησιμοποιείται ο ιστότοπός μας και να βελτιώσουμε την εμπειρία σας."
    }
  }
};
